import React from 'react';
import { t } from 'i18n';

const i18nOpts = { scope: 'audit.show' };

const DataLogs = ({
  isExpanded,
  logs,
}) => (
  <tr className={isExpanded ? 'data-log__expanded' : 'data-log__collapsed'}>
    <td
      colSpan={10}
      className="data-log-col"
    >
      <table className="audit-log-table">
        <thead>
          <tr className="table__head">
            <th>{t('table_header.audit_id', i18nOpts)}</th>
            <th>{t('table_header.care_plan', i18nOpts)}</th>
            <th>{t('table_header.care_plan_id', i18nOpts)}</th>
            <th>{t('table_header.subject', i18nOpts)}</th>
            <th>{t('table_header.mrn', i18nOpts)}</th>
            <th>{t('table_header.record_type', i18nOpts)}</th>
            <th>{t('table_header.record_id', i18nOpts)}</th>
            <th>{t('table_header.action', i18nOpts)}</th>
            <th>{t('table_header.comment', i18nOpts)}</th>
            <th>{t('table_header.field', i18nOpts)}</th>
            <th>{t('table_header.previous_value', i18nOpts)}</th>
            <th>{t('table_header.current_value', i18nOpts)}</th>
          </tr>
        </thead>

        <tbody>
          {
            logs?.length
              ? logs.map(({
                id,
                is_odd_row,
                care_plan_uuid,
                care_plan_title,
                subject_name,
                mrn,
                record_type,
                auditable_id,
                action,
                comment,
                field,
                previous_value,
                current_value,
                remote_address,
              }, i) => (
                <tr key={`data-log-${i}`} className={is_odd_row ? 'audit-log-table__odd-row' : ''}>

                  <td>{id}</td>
                  <td>
                    {!!care_plan_uuid && (
                      <a
                        href={`/care_plans/${care_plan_uuid}`}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                      >
                        {care_plan_title || t('untitled', i18nOpts)}
                      </a>
                    )}
                  </td>
                  <td>{care_plan_uuid}</td>
                  <td className="audit-log-table__subject_column">{subject_name}</td>
                  <td>{mrn}</td>
                  <td>{record_type}</td>
                  <td>{auditable_id}</td>
                  <td>{action}</td>
                  <td>{comment}</td>
                  <td>{field}</td>
                  <td>{previous_value ? JSON.stringify(previous_value) : '-'}</td>
                  <td>{current_value ? JSON.stringify(current_value) : '-'}</td>
                </tr>)
              )
              : null
          }
        </tbody>
      </table>
    </td>
  </tr>
);

export default DataLogs;
